import * as actions from "../actionTypes"

const initialState = {
    value: false,
}

export default function supplierShowDocuments(state = initialState, action) {
    switch (action.type) {
        case actions.SET_SUPPLIER_SHOW_DOCUMENTS: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
